// import { createSlice, createAsyncThunk } from "@reduxjs/toolkit"
// import {
//   addAttributeApi,
//   getAttributeApi,
//   getAttributeByIdApi,
//   updateAttributeApi,
//   deleteAttributeApi,
//   getUniqueAttributeKeysApi,
//   getAttributesByKeyApi,
//   importAttributesApi,
//   addKeyToAttributeApi,
//   removeKeyFromAttributeApi
// } from "../../../services/Web/attributes.service"

// import { toastError, toastSuccess } from "../../../utility/toastutill"

// // ✅ Get all attributes
// export const getAllAttributes = createAsyncThunk(
//   "attribute/getAllAttributes",
//   async () => {
//     try {
//       const response = await getAttributeApi()
//       return response.data.data
//     } catch (error) {
//       toastError(error)
//       return error
//     }
//   }
// )

// // ✅ Get attributes with params
// export const getAttributes = createAsyncThunk(
//   "attribute/getAttributes",
//   async (params) => {
//     let query = ``

//     if (params) {
//       if (params.sort) query += `sort=${params.sort}`
//       if (params.sortColumn) query += `&sortColumn=${params.sortColumn}`
//       if (params.q) query += `&q=${params.q}`
//       if (params.perPage) query += `&perPage=${params.perPage}`
//       if (params.page) query += `&page=${params.page}`
//     }

//     const response = await getAttributeApi(query)
//     return {
//       params,
//       data: response.data.data,
//       totalPages: response.data.totalElements
//     }
//   }
// )

// // ✅ Get by ID
// export const getAttributeById = createAsyncThunk(
//   "attribute/getAttributeById",
//   async (id) => {
//     try {
//       const res = await getAttributeByIdApi(id)
//       return res.data.data
//     } catch (error) {
//       toastError(error)
//       return error
//     }
//   }
// )

// // ✅ Add Attribute
// export const addAttribute = createAsyncThunk(
//   "attribute/addAttribute",
//   async (formData, { dispatch, getState }) => {
//     try {
//       const res = await addAttributeApi(formData)
//       toastSuccess("Attribute Added Successfully")

//       await dispatch(getAttributes(getState().attribute.params))
//       await dispatch(getAllAttributes())

//       return res.data.success
//     } catch (error) {
//       toastError(error)
//       return error
//     }
//   }
// )

// // ✅ Update Attribute
// export const updateAttribute = createAsyncThunk(
//   "attribute/updateAttribute",
//   async (formData, { dispatch, getState }) => {
//     try {
//       const res = await updateAttributeApi(formData.id, formData)

//       await dispatch(getAttributes(getState().attribute.params))
//       await dispatch(getAllAttributes())

//       return res.data.success
//     } catch (error) {
//       toastError(error)
//       return error
//     }
//   }
// )

// // ✅ Delete Attribute
// export const deleteAttribute = createAsyncThunk(
//   "attribute/deleteAttribute",
//   async (id, { dispatch, getState }) => {
//     try {
//       await deleteAttributeApi(id)

//       await dispatch(getAttributes(getState().attribute.params))
//       await dispatch(getAllAttributes())

//       return id
//     } catch (error) {
//       toastError(error)
//       return error
//     }
//   }
// )

// // ✅ Get unique keys
// export const getUniqueKeys = createAsyncThunk(
//   "attribute/getUniqueKeys",
//   async () => {
//     try {
//       const res = await getUniqueAttributeKeysApi()
//       return res.data.data
//     } catch (error) {
//       toastError(error)
//       return error
//     }
//   }
// )

// // ✅ Get attributes by a key
// export const getAttributesByKey = createAsyncThunk(
//   "attribute/getAttributesByKey",
//   async (key) => {
//     try {
//       const res = await getAttributesByKeyApi(key)
//       return res.data
//     } catch (error) {
//       toastError(error)
//       return error
//     }
//   }
// )

// // ✅ Import Attributes
// export const importAttributes = createAsyncThunk(
//   "attribute/importAttributes",
//   async (formData, { dispatch }) => {
//     try {
//       await importAttributesApi(formData)
//       await dispatch(getAllAttributes())
//       toastSuccess("Imported successfully!")
//       return true
//     } catch (error) {
//       toastError(error)
//       return error
//     }
//   }
// )

// // ✅ Add key to attribute
// export const addKeyToAttribute = createAsyncThunk(
//   "attribute/addKeyToAttribute",
//   async ({ id, payload }, { dispatch }) => {
//     try {
//       await addKeyToAttributeApi(id, payload)
//       await dispatch(getAttributeById(id))
//       return true
//     } catch (error) {
//       toastError(error)
//       return error
//     }
//   }
// )

// // ✅ Remove key from attribute
// export const removeValueFromAttribute = createAsyncThunk(
//   "attributes/removeValueFromAttribute",
//   async ({ id, value }, thunkAPI) => {
//     try {
//       const res = await axios.put(`${BASE_URL}/${id}/remove-value`, {
//         value // ✅ must send "value", not "key"
//       })
//       toastSuccess("Value removed successfully")
//       return res.data
//     } catch (err) {
//       return thunkAPI.rejectWithValue(err.response?.data || err.message)
//     }
//   }
// )


// // ✅ Slice
// export const attributeSlice = createSlice({
//   name: "attribute",
//   initialState: {
//     data: [],
//     total: 1,
//     params: {},
//     allData: [],
//     selectedAttribute: null,
//     uniqueKeys: [],
//     attributesByKey: [],
//     loading: false,
//     success: false
//   },
//   reducers: {},
//   extraReducers: (builder) => {
//     builder
//     .addCase(getAttributes.pending, (state) => {
//     state.loading = true
//    })
//       .addCase(getAllAttributes.fulfilled, (state, action) => {
//         state.allData = action.payload
//       })
//       .addCase(getAttributes.fulfilled, (state, action) => {
//         state.data = action.payload.data
//         state.total = action.payload.totalPages
//         state.params = action.payload.params
//       state.loading = false
//       })
//    .addCase(getAttributes.rejected, (state) => {
//      state.loading = false
//    })
//       .addCase(getAttributeById.fulfilled, (state, action) => {
//         state.selectedAttribute = action.payload
//       })
//       .addCase(addAttribute.fulfilled, (state, action) => {
//         state.success = action.payload
//       })
//       .addCase(updateAttribute.fulfilled, (state) => {
//         state.selectedAttribute = null
//       })
//       .addCase(deleteAttribute.fulfilled, (state) => {
//         state.selectedAttribute = null
//       })
//       .addCase(getUniqueKeys.fulfilled, (state, action) => {
//         state.uniqueKeys = action.payload
//       })
//       .addCase(getAttributesByKey.fulfilled, (state, action) => {
//         state.attributesByKey = action.payload
//       })
//   }
// })

// export default attributeSlice.reducer
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit"
import {
  addAttributeApi,
  getAttributeApi,
  getAttributeByIdApi,
  updateAttributeApi,
  deleteAttributeApi,
  getUniqueAttributeKeysApi,
  getAttributesByKeyApi,
  importAttributesApi,
  removeKeyFromAttributeApi
} from "../../../services/Web/attributes.service"

import { toastError, toastSuccess } from "../../../utility/toastutill"

// ✅ Get all without pagination
export const getAllAttributes = createAsyncThunk(
  "attribute/getAllAttributes",
  async (_, { rejectWithValue }) => {
    try {
      const res = await getAttributeApi()
      return res.data.data
    } catch (error) {
      toastError(error)
      return rejectWithValue(error)
    }
  }
)

// ✅ Get list with filters (params optional fix)
export const getAttributes = createAsyncThunk(
  "attribute/getAttributes",
  async (params = {}, { rejectWithValue }) => {
    try {
      let query = ``

      if (params.sort) query += `sort=${params.sort}`
      if (params.sortColumn) query += `&sortColumn=${params.sortColumn}`
      if (params.q) query += `&q=${params.q}`
      if (params.perPage) query += `&perPage=${params.perPage}`
      if (params.page) query += `&page=${params.page}`

      const res = await getAttributeApi(query)

      return {
        params,
        data: res.data.data,
        totalPages: res.data.attributeCount
      }
    } catch (error) {
      return rejectWithValue(error)
    }
  }
)

// ✅ Get by ID
export const getAttributeById = createAsyncThunk(
  "attribute/getAttributeById",
  async (id, { rejectWithValue }) => {
    try {
      const res = await getAttributeByIdApi(id)
      return res.data.data
    } catch (error) {
      toastError(error)
      return rejectWithValue(error)
    }
  }
)

// ✅ Add
// ✅ Add Attribute - Include isCompare
export const addAttribute = createAsyncThunk(
  "attribute/addAttribute",
  async ({ key, values, isCompare }, { dispatch, getState, rejectWithValue }) => {
    try {
      const res = await addAttributeApi({ key, values, isCompare }) // ✅ Added isCompare

      // ✅ Backend may return success:false (duplicate value or key exists)
      if (res?.data?.success === false) {
        toastError(res.data.message) // Show backend message
        return rejectWithValue(res.data.message)
      }

      toastSuccess("Attribute Added Successfully")

      dispatch(getAttributes(getState().attribute.params))
      dispatch(getAllAttributes())

      return res.data
    } catch (error) {
      const msg =
        error?.response?.data?.message ||
        error?.message ||
        "Something went wrong"

      toastError(msg) // ✅ Display readable error
      return rejectWithValue(msg)
    }
  }
)


// ✅ Update - Include isCompare
export const updateAttribute = createAsyncThunk(
  "attribute/updateAttribute",
  async ({ id, key, values, isCompare }, { dispatch, getState, rejectWithValue }) => {
    try {
      await updateAttributeApi(id, { key, values, isCompare }) // ✅ Added isCompare
      toastSuccess("Attribute Updated Successfully")

      dispatch(getAttributes(getState().attribute.params))
      dispatch(getAllAttributes())

      return true
    } catch (error) {
      toastError(error)
      return rejectWithValue(error)
    }
  }
)

// ✅ Delete
export const deleteAttribute = createAsyncThunk(
  "attribute/deleteAttribute",
  async (id, { dispatch, getState, rejectWithValue }) => {
    try {
      await deleteAttributeApi(id)
      toastSuccess("Attribute Deleted Successfully")

      dispatch(getAttributes(getState().attribute.params))
      dispatch(getAllAttributes())

      return true
    } catch (error) {
      toastError(error)
      return rejectWithValue(error)
    }
  }
)

// ✅ Get unique keys
export const getUniqueKeys = createAsyncThunk(
  "attribute/getUniqueKeys",
  async (_, { rejectWithValue }) => {
    try {
      const res = await getUniqueAttributeKeysApi()
      return res.data.data
    } catch (error) {
      toastError(error)
      return rejectWithValue(error)
    }
  }
)

// ✅ Get values of a specific key
export const getAttributesByKey = createAsyncThunk(
  "attribute/getAttributesByKey",
  async (key, { rejectWithValue }) => {
    try {
      const res = await getAttributesByKeyApi(key)
      return res.data.data
    } catch (error) {
      toastError(error)
      return rejectWithValue(error)
    }
  }
)

// ✅ Remove value from attribute.values
export const removeValueFromAttribute = createAsyncThunk(
  "attribute/removeValue",
  async ({ id, value }, { dispatch, rejectWithValue }) => {
    try {
      await removeKeyFromAttributeApi(id, { value })
      toastSuccess("Value Removed Successfully")

      dispatch(getAttributeById(id))
      return true
    } catch (error) {
      toastError(error)
      return rejectWithValue(error)
    }
  }
)

// ✅ Import attributes
export const importAttributes = createAsyncThunk(
  "attribute/import",
  async (formData, { dispatch, rejectWithValue }) => {
    try {
      await importAttributesApi(formData)
      toastSuccess("Imported successfully!")

      dispatch(getAllAttributes())
      return true
    } catch (error) {
      toastError(error)
      return rejectWithValue(error)
    }
  }
)

export const attributeSlice = createSlice({
  name: "attribute",
  initialState: {
    data: [],
    total: 1,
    params: {},
    allData: [],
    selectedAttribute: null,
    uniqueKeys: [],
    attributesByKey: [],
    loading: false,
    success: false
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getAttributes.pending, (state) => {
        state.loading = true
      })
      .addCase(getAttributes.fulfilled, (state, action) => {
        state.data = action.payload.data
        state.total = action.payload.totalPages
        state.params = action.payload.params
        state.loading = false
      })
      .addCase(getAllAttributes.fulfilled, (state, action) => {
        state.allData = action.payload
      })
      .addCase(getAttributeById.fulfilled, (state, action) => {
        state.selectedAttribute = action.payload
      })
      .addCase(updateAttribute.fulfilled, (state) => {
        state.selectedAttribute = null
      })
      .addCase(deleteAttribute.fulfilled, (state) => {
        state.selectedAttribute = null
      })
      .addCase(getUniqueKeys.fulfilled, (state, action) => {
        state.uniqueKeys = action.payload
      })
      .addCase(getAttributesByKey.fulfilled, (state, action) => {
        state.attributesByKey = action.payload
      })
  }
})

export default attributeSlice.reducer
